import { FONTS } from '../../../config/app-config';
// src/components/navigation/header/ProductSelector.js
import React, { useState } from 'react';
import { Box, Typography, Menu, MenuItem, Tooltip } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

// falls ihr schöne Labels braucht
const productMapping = {
    supervisor: 'Supervisor',
    addin:      'Add-In',
    com:        'COM-Interface',
};

function ProductSelector({
                             options = [],          // z.B. ['addin','com']
                             selectedRelease,
                             setSelectedRelease,
                         }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [tipOpen, setTipOpen]   = useState(false);
    const menuOpen = Boolean(anchorEl);

    const handleOpen  = e => options.length && setAnchorEl(e.currentTarget);
    const handleClose = ()   => setAnchorEl(null);

    // Label des aktuellen Produkts
    const label = productMapping[selectedRelease.product]
        || selectedRelease.product
        || 'Select Product';

    return (
        <>
            <Tooltip
                title="Choose Product"
                placement="bottom"
                open={tipOpen && !menuOpen}
                onOpen={() => setTipOpen(true)}
                onClose={() => setTipOpen(false)}
                disableFocusListener
                disableTouchListener
            >
                <Box
                    component="button"
                    type="button"
                    aria-label={`Choose Product: ${label}`}
                    onClick={(e) => { setTipOpen(false); handleOpen(e); }}
                    aria-haspopup="menu"
                    aria-expanded={menuOpen ? 'true' : undefined}
                    sx={{
                        color: 'inherit',
                        font: 'inherit',
                        background: 'transparent',
                        border: 0,
                        p: 0,
                        minWidth: { xs: 44, sm: 0 },
                        minHeight: { xs: 44, sm: 0 },
                        justifyContent: 'center',
                        display:'flex',
                        alignItems:'center',
                        cursor: options.length ? 'pointer' : 'default',
                        gap: 0.5
                    }}
                >
                    <CategoryIcon />
                    <Typography
                        variant="caption"
                        sx={{
                            display:{ xs:'none',lg:'block' },
                            fontFamily:FONTS.body,
                            fontSize: '1rem',
                        }}
                    >
                        {label}
                    </Typography>
                    <ArrowDropDownIcon fontSize="small" />
                </Box>
            </Tooltip>

            <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleClose}>
                {options.length === 0 && (
                    <MenuItem disabled sx={{ fontFamily:FONTS.body}}>
                        Keine Produkte verfügbar
                    </MenuItem>
                )}
                {options.map(key => (
                    <MenuItem
                        key={key}
                        onClick={() => {
                            setSelectedRelease(selectedRelease.with({
                                product: key,
                                language: key === 'supervisor' ? selectedRelease.language : 'en',
                            }));
                            handleClose();
                        }}
                        sx={{ fontFamily:FONTS.body }}
                    >
                        {productMapping[key] || key}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

export default ProductSelector;

